import React, { useEffect, useState } from 'react';
import { AvForm, AvGroup } from 'availity-reactstrap-validation';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Label } from 'reactstrap';

const OrderClassesField = ({
  object,
  isDisabled,
  onSuccessCallback,
  setter,
  ...props
}) => {
  const intl = useIntl();
  const [selectedAvailableFor, setSelectedAvailableFor] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const options = [
    { value: 'inhouse', messageId: 'orderClassInhouseLabel' },
    { value: 'takeaway', messageId: 'orderClassTakeawayLabel' },
  ];

  useEffect(() => {
    const classesFound = options.filter((option) => {
      return object?.classes?.includes(option?.value);
    });
    setSelectedAvailableFor(classesFound);
    setIsSubmitting(false);
    if (!object?.classes) {
      setter({ ...object, classes: classesFound });
    }
  }, [object]);

  return (
    <AvForm>
      <AvGroup className="react-select form-label-group">
        <Select
          id="classes"
          isMulti={true}
          isDisabled={isSubmitting}
          name="classes"
          className={'react-select-container'}
          classNamePrefix={'react-select'}
          value={selectedAvailableFor}
          getOptionLabel={(availableFor) =>
            intl.formatMessage({ id: availableFor?.messageId })
          }
          getOptionValue={(availableFor) => availableFor?.value}
          onChange={(option) => {
            setter({ ...object, classes: option?.map(({ value }) => value) });
          }}
          placeholder={intl.formatMessage({
            id: 'selectAvailableForLabel',
          })}
          options={options}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
          {...props}
        />
        <Label className="floating-label" for={object?.id}>
          <FormattedMessage id="availableForTitle" />
        </Label>
      </AvGroup>
    </AvForm>
  );
};

export default OrderClassesField;
